import { render, staticRenderFns } from "./PersonInfo.vue?vue&type=template&id=43c933d6&"
import script from "./PersonInfo.vue?vue&type=script&lang=ts&"
export * from "./PersonInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports